<template>
  <ul class="menu-nav">
    <template  v-for="(item,idx) in routes">
      <template v-if="item.hidden==false&&item.children.length==1">
        <router-link  :to="item.path"  v-slot="{ href, navigate, isActive, isExactActive }" :key="idx">
          <li
            :key="idx"
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']">
            <a :href="href" class="menu-link" @click="navigate">
              <!-- media/svg/icons/Navigation/Up-2.svg -->
              <span class="menu-icon" >
                <inline-svg class="svg-icon"  :src="svgIcon(item.children[0].meta.icon,isActive)" />
              </span>
              <!-- <inline-svg style="width:16px;height:16px"  v-if="item.children[0].meta.icon=='menu-icon-home'"  :src="'media/navMenu/'+item.children[0].meta.icon+'.svg'" /> -->
              <!-- <span>{{'media/navMenu/'+item.children[0].meta.icon}}</span> -->
               <!-- <inline-svg
                        src="media/svg/icons/General/Settings-1.svg"
                      ></inline-svg> -->
              <!-- <i v-else class="menu-icon" :class="item.children[0].meta.icon?item.children[0].meta.icon:''"></i> -->
              <span class="menu-text">{{item.children[0].meta.title}}</span>
            </a>
          </li>
        </router-link>
      </template>
      <template v-if="item.hidden==false&&item.children.length>1">
        <li
          :key="idx"
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          v-bind:class="{ 'menu-item-open': hasActiveChildren(item.path) }">
          <a href="#" class="menu-link menu-toggle">
            <i class="menu-icon flaticon2-digital-marketing"></i>
            <span class="menu-text">{{item.meta.title}}</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="menu-submenu">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <li aria-haspopup="true" class="menu-item menu-item-parent">
                <span class="menu-link">
                  <span class="menu-text">{{item.meta.title}}</span>
                </span>
              </li>
              <template  v-for="(child,ix) in item.children"  >
                <template v-if="!child.children">
                  <router-link
                    :key="ix"
                    :to="item.path+'/'+child.path"
                    v-slot="{ href, navigate, isActive, isExactActive }">
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']">
                      <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span class="menu-text">{{child.meta.title}}</span>
                      </a>
                    </li>
                  </router-link>
                </template>
                <template v-if="child.children">
                  <li
                    :key="ix"
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item menu-item-submenu"
                    v-bind:class="{'menu-item-open': hasActiveChildren(child.path)}">
                    <a href="#" class="menu-link menu-toggle">
                      <i class="menu-bullet menu-bullet-dot">
                        <span></span>
                      </i>
                      <span class="menu-text">{{child.meta.title}}</span>
                      <i class="menu-arrow"></i>
                    </a>
                    <div class="menu-submenu">
                      <span class="menu-arrow"></span>
                      <ul class="menu-subnav">
                        <li aria-haspopup="true" class="menu-item menu-item-parent">
                          <span class="menu-link">
                            <span class="menu-text"></span>
                          </span>
                        </li>
                        <router-link
                          v-for="(chl,inx) in child.children" 
                          :key="inx"
                          :to="item.path+'/'+child.path+'/'+chl.path"
                          v-slot="{ href, navigate, isActive, isExactActive }">
                          <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[ isActive && 'menu-item-active',isExactActive && 'menu-item-active' ]">
                            <a :href="href" class="menu-link" @click="navigate">
                              <i class="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span class="menu-text">{{chl.meta.title}}</span>
                            </a>
                          </li>
                        </router-link>
                      </ul>
                    </div>
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </li>
      </template>
    </template>
    <!-- <router-link
      to="/builder"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-expand"></i>
          <span class="menu-text">Layout Builder</span>
        </a>
      </li>
    </router-link> -->

    <!-- <li class="menu-section">
      <h4 class="menu-text">Components</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li> -->

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon flaticon2-digital-marketing"></i>
        <span class="menu-text">Vue Bootstrap</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Vue Bootstrap</span>
            </span>
          </li>

          

         

          
        </ul>
      </div>
    </li> -->
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    svgIcon(name,state){
      // if(state){
      //   return '/media/navMenu/'+name+'-active.svg'
      // }else{
        return '/media/navMenu/'+name+'.svg'
      // }
      
    }
  },
  computed: {
    routes() {
      // console.log(this.$router.options.routes)
      return this.$router.options.routes;
    },
    
  },
  created() {
    // console.log(this.routes)
  }
};
</script>
<style lang="scss" scoped>
.menu-icon{
  .svg-icon{
    width:20px !important;
    height:20px !important;
  }
}
.menu-item-active .menu-icon{
  .svg-icon{ color:#5371FF  !important;};
}
</style>
